/* Exemple de classe */
class Tabs {
	constructor() {
		this.dom = {
			tabs: $(".tabs"),
			buttons: $(".tabs__header button"),
			items: $(".tabs__item")
		};

		if (!this.dom.tabs) return;

		this.init();
	}

	init() {
		this.dom.buttons.on("click", e => {
			const target = $(e.currentTarget);
			const index = target.parent().index();

			this.dom.items.removeClass("is-active");
			this.dom.items.eq(index).addClass("is-active");

			this.dom.buttons.removeClass("is-active");
			this.dom.buttons.eq(index).addClass("is-active");
		});
	}
}
